export const EndCustomerRoute = {
  ENDCUSTOMERS: 'endcustomers',
};

export const EndCustomerPathName = {
  ENDCUSTOMERS: 'endcustomers',
  ENDCUSTOMERFORM_NEW: 'endcustomerform:new',
  ENDCUSTOMERFORM: 'endcustomerform',
};
